import { action, observable } from 'mobx';

const DEFAULT_CORRECT_PIN = '1111';

class RecognitionStore {
  @observable public pin: string[] = [];
  @observable public isPinValid: boolean = false;
  // config value?
  @observable private _correctPin = DEFAULT_CORRECT_PIN;

  @action
  public changePin = (value: string[]) => {
    this.pin = value;
    this.isPinValid = value.join('') === this._correctPin;
  };
}

export default new RecognitionStore();
